import { EventBus } from "../../../eventbus";
import { userHasSomeRights } from "../../../functions/userRights";

export default {
  props: {
    flavorIcon: String,
    id: String,
    name: String,
    color: String,
    description: String,
    myspace: [Number, Boolean],
    time_past: String,
  },
  data() {
    return {
      rights: ["delete_spaces", "edit_spaces", "make-private_spaces"],
    };
  },
  methods: {
    setColor() {
      if (this.myspace == 0) {
        return `#${this.color}`;
      }

      return "";
    },
    emit(name, data, e) {
      e.preventDefault();

      EventBus.$emit(name, data);
    },
  },
  computed: {
    hasEdit() {
      return userHasSomeRights(this.rights, this);
    },
  },
};
